// SHADOW MARKET™ — Paywall A/B bucketing helper.
//
// Bucketing rules:
//   - Authenticated users: deterministic 50/50 split using a simple hash of
//     the user id. The user always sees the same variant across reloads
//     and devices.
//   - Anonymous users: a per-browser sticky bucket stored in localStorage so
//     view → checkout_click events tie to the same variant.
//
// Variants:
//   "A" = control (current copy)
//   "B" = emotional copy with pricing hook

const STORAGE_KEY = "rebel_paywall_ab";

const hashString = (str) => {
  let h = 5381;
  for (let i = 0; i < str.length; i += 1) {
    h = ((h << 5) + h) ^ str.charCodeAt(i); // djb2 xor
  }
  return Math.abs(h);
};

export const getPaywallVariant = (userId) => {
  if (userId) {
    return hashString(String(userId)) % 2 === 0 ? "A" : "B";
  }
  try {
    const cached = window.localStorage.getItem(STORAGE_KEY);
    if (cached === "A" || cached === "B") return cached;
    const v = Math.random() < 0.5 ? "A" : "B";
    window.localStorage.setItem(STORAGE_KEY, v);
    return v;
  } catch {
    return "A";
  }
};
